<template>
  <div v-bind:style="{ height: height + 'px' }">
    <div class="content_header">
      <v-toolbar flat color="white mx-2">
        <v-toolbar-title><span class='pr-3'>レビュー管理</span></v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>

        <span style="font-weight:bold;color:#e91e63;">カテゴリ選択：</span>
        <select
          v-model="category"
          v-on:change="selected"
          style="
            border: 2px solid #2196f3;
            width: 180px;
            padding: 6px;
            margin-right: 10px;
            border-radius: 6px;
          "
        >
          <option v-for="(value, key) in categoryItems" :key="key">
            {{ key }}
          </option>
        </select>

        <span style="font-weight:bold;color:#e91e63;">記事選択：</span>

        <v-select
          v-if="selectedItem"
          v-model="article_num"
          :items="selectedItem"
          @change="dataSearch()"
          style="max-width: 180px; margin-top: 16px"
        ></v-select>

        <v-progress-circular v-if="loading" indeterminate></v-progress-circular>

        <a @click="dataSearch()" class="mr-10 ml-10">更新</a>

        <!-- <a target="_blank" :href="site_url + category + '/' + article_num"
          >記事へ飛ぶ</a
        > -->

        <!-- <v-btn class="primary" @click="dataSearch()">データ取得</v-btn> -->
      </v-toolbar>
    </div>

    <v-card class="ma-4 pa-2">「カテゴリ選択」で表示したいレビューのカテゴリを指定し、「記事選択」で該当の記事のページを選んでください。</v-card>
    <v-card class="ma-4">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        id="data_search"
        class="mx-4 pa-4"
        placeholder="内容検索"
        clearable
      ></v-text-field>

      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        :items-per-page="100"
        :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
      >
        <template v-slot:item.del_flg="{ item }">
          <p v-if="item.del_flg == 0"></p>
          <p v-else><span style="color: red">削除</span></p>
        </template>

        <template v-slot:item.category="{ item }">
          <div @click="editItem(item)" text>
            <div
              style="
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                font-size: 12px;
                padding-right: 4px;
              "
            >
              {{ item.article_title }}
            </div>

            <a
              target="_blank"
              :href="site_url + item.category + '/' + item.article_num"
            >
              {{ item.category }} <br />{{ item.article_num }}</a
            >
          </div>
        </template>

        <template v-slot:item.content="{ item }">
          <div @click="editItem(item)" text>
            <table class="main_table">
              <tr>
                <th width="50">日付</th>
                <td>
                  <span class="teal--text text--darken-4 caption">
                    {{ item.create_date }}
                  </span>
                </td>
                <th>name</th>
                <td>
                  <span class="teal--text text--darken-4 caption">
                    {{ item.author_name }}
                  </span>
                </td>
              </tr>
              <tr>
                <th>内容</th>
                <td colspan="3" class="pt-4 pb-4">
                  <span class="text--darken-4 font-weight-bold">
                    {{ item.content }}
                  </span>
                </td>
              </tr>

              <tr>
                <th>評価</th>
                <td colspan="3" class="pt-4 pb-4">
                  <span class="text--darken-3">
                    {{ item.review_val }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </template>

        <template v-slot:item.memo="{ item }">
          <div @click="editItem(item)" text>-</div>
        </template>

        <template v-slot:item.source="{ item }">
          <div @click="editItem(item)" text style="text-transform: none">
            {{ item.source }}
          </div>
        </template>

        <template v-slot:item.edit="{ item }">
          <v-icon small color="primary" @click="deleteItem(item)"
            >fas fa-trash</v-icon
          >
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>



<script>
// Ajax通信ライブラリ
import axios from "axios";

export default {
  data() {
    return {
      //検索用パラメータ
      site_url: "",
      search: "",
      category: "",
      article_num: "",
      selectedKey: "",
      selectedItem: "",
      categoryItems: {},

      loading: false,

      height: 0,
      dialog: false,
      headers: [
        {
          text: "状態",
          value: "del_flg",
          width: "30px",
          align: "center",
        },
        {
          text: "表示上のID",
          value: "comment_id",
          width: "70px",
          align: "center",
        },
        { text: "category", value: "category", width: "110px" },
        { text: "content", value: "content", width: "300px" },
        { text: "", value: "memo", width: "20px", fixed: true },
        {
          text: "author",
          value: "author_ip",
          width: "114px",
          align: "left",
          fixed: true,
        },
        { text: "DB_ID", value: "unique_id", width: "44px", align: "center" },

        { text: "編集", value: "edit", width: "40px" },
      ],
      list: [],
      editedIndex: -1,
      editedItem: {
        id: "",
        category: "",
        title: "",
        source: "",
        memo: "",
        img_count: 0,
        imageData1: "",
        imageData2: "",
      },

      //画像拡大用
      imgDialog: false,

      // 入力規則
      required: (value) => !!value || "必ず入力してください", // 入力必須の制約
    };
  },

  computed: {},

  methods: {
    link() {
      return "aaaa";
    },

    editItem(item) {
      this.editedIndex = this.list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;

      //画像のロード

      if (item.img_count == 1) {
        this.uploadImageUrl1 =
          "https://tool-test.matomeroyal.com/wp-content/themes/tool/enginner_img/" +
          item.id +
          "_1";
        this.uploadImageUrl2 = "";
      } else if (item.img_count == 2) {
        this.uploadImageUrl1 =
          "https://tool-test.matomeroyal.com/wp-content/themes/tool/enginner_img/" +
          item.id +
          "_1";

        this.uploadImageUrl2 =
          "https://tool-test.matomeroyal.com/wp-content/themes/tool/enginner_img/" +
          item.id +
          "_2";
      } else {
        this.uploadImageUrl1 = "";
        this.uploadImageUrl2 = "";
      }

      // this.loadImg(item);
    },

    //画像の拡大表示
    scaleImg(img_data) {
      if (img_data != "") {
        this.uploadImageUrl_scallview = img_data;
        this.imgDialog = true;
      }
    },
    closeScaleDialog() {
      this.imgDialog = false;
    },

    save() {
      // console.log(this.editedItem)
      var self = this;
      axios
        .post(process.env.VUE_APP_ENGINEER_WORK_SAVE, {
          data: this.editedItem,
        })
        .then(function (response) {
          console.log(response);
          //新規追加
          if (response.data["status"] == 1) {
            self.editedItem["id"] = response.data["last_id"];
            self.list.push(self.editedItem);
            //更新
          } else if (response.data["status"] == 2) {
            Object.assign(self.list[self.editedIndex], self.editedItem);
          } else {
            alert("更新失敗！！");
          }
          self.close();
        });
    },

    //削除
    deleteItem(item) {
      var result = confirm("選択したデータを削除しますか？");
      if (result == false) {
        return;
      }

      if (item.del_flg == 0) {
        item.del_flg = 1;
      } else {
        item.del_flg = 0;
      }

      var self = this;
      axios
        .post(process.env.VUE_APP_REVIEW_UPDATE, {
          data: item,
        })
        .then(function (response) {
          console.log(response);
          self.close();
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    },

    itemPush: function (value, type) {
      var reply = "";
      if (type == "child") {
        reply = "返信";
      }

      const check = reply + value.review_id;
      const item = {
        unique_id: value.unique_id,
        comment_id: check,
        type: type,
        author_name: value.author_name,
        title: value.user_title,
                article_title: value.title,

        review_val: value.review_val || "",
        content: value.user_content,
        create_date: value.create_date,
        category: value.category_slug,
        article_num: value.article_num || "",
        author_ip: value.author_IP,
        del_flg: value.del_flg,
      };
      return item;
    },

    dataSearch: function () {
      // "?category=utaware-lostflag&article_num=6253825
      this.loading = true;
      this.list = [];
      axios
        .get(
          process.env.VUE_APP_REVIEW_LIST +
            "?category=" +
            this.category +
            "&article_num=" +
            this.article_num
        )
        .then((response) => {
          // v-data-tableを使うときは配列に格納する
          const items = [];
          const values = Object.values(response.data.parent);
          const child = response.data.child;

          values.forEach((value) => {
            const item = this.itemPush(value, "parent");
            items.push(item);
            // console.log(value.unique_id);

            //返信があればさらに追加
            if (child[value.unique_id] != null) {
              child[value.unique_id].forEach((child_value) => {
                console.log(child_value);

                child_value["review_id"] = child_value["comment_id"];
                child_value["user_content"] = child_value["comment"];

                const item = this.itemPush(child_value, "child");
                items.push(item);
              });
            }
          });
          this.list = items;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selected: function () {
      this.article_num = "";
      this.selectedItem = Array.from(this.categoryItems[this.category]);
      this.selectedItem.unshift("all");
      this.site_url = process.env.VUE_APP_DOMAIN_URL;
    },
  },

  created: function () {
    axios.get(process.env.VUE_APP_REVIEW_DATA_LIST).then((response) => {
      // v-data-tableを使うときは配列に格納する
      // const items = [];
      // console.log(response.data["test"]);
      this.categoryItems = response.data;

      // for (let key in value) {
      //   console.log('key:' + key + ' value:' + value[key]);
      // }

      // // const values = Object.values(response.data);
      // for(var i = 0 ; i < response.data.length ; ++ i){
      //   console.log(response.data[i])
      // }

      //   console.log(response.data)

      // response.data.forEach((key,value) => {
      //   // items[value.category_name] = value.article_num

      //   console.log(key,value)
      // });
    });
  },
};
</script>

<style>
.v-data-table th span {
  font-size: 12px !important;
}

.v-data-table table th {
  font-weight: normal;
  color: #888;
}

.v-data-table td,
.v-data-table th {
  padding: 2px;
  height: 30px !important;
}
.v-data-table tr:last-child td,
.v-data-table tr:last-child th {
  border: none;
}
table tr:nth-child(odd) td {
  background: #fbf9ff;
}
.main_table td,
.main_table th {
  background: transparent !important;
}

.main_table tr:last-child th,
.main_table tr:last-child td {
  border: none !important;
}
</style>